var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimatedLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "outline",
    d: "M73.7883 160.729C41.9943 152.511 18.7003 123.123 20.0563 88.6794C21.4932 51.557 51.7086 21.4845 89.0073 20.0544C123.614 18.725 153.142 41.9089 161.399 73.5324C163.767 82.6367 156.845 91.5195 147.394 91.5195H147.333C140.695 91.5195 135.008 86.9875 133.308 80.6023C128.249 61.6282 110.379 47.7904 89.5132 48.8983C67.7776 50.0464 50.1907 67.5501 49.0372 89.183C47.9241 109.95 61.8276 127.735 80.8716 132.751C87.287 134.443 91.8406 140.103 91.8406 146.71V146.77C91.8406 156.176 82.9156 163.085 73.7883 160.729Z",
    fill: "#194440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "point",
    d: "M98.379 93.9531C107.399 93.9531 114.711 86.6756 114.711 77.6982C114.711 68.7209 107.399 61.4434 98.379 61.4434C89.359 61.4434 82.0469 68.7209 82.0469 77.6982C82.0469 86.6756 89.359 93.9531 98.379 93.9531Z",
    fill: "#194440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedLogo);
export default __webpack_public_path__ + "static/media/animated-logo.9fbd57c1dc6b94dc5c267a61bf21b765.svg";
export { ForwardRef as ReactComponent };